/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Processing_NoteInputs */



/**
* | output |
* | --- |
* | "Hang on, your report will appear here in a moment." |
*
* @param {Meeting_Offline_Processing_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_processing_note = /** @type {((inputs?: Meeting_Offline_Processing_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Processing_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Even geduld, je verslag verschijnt zo meteen hier.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un instant, votre compte rendu va apparaître ici.")
	return /** @type {LocalizedString} */ ("Hang on, your report will appear here in a moment.")
});